import {getCookieCustom, setCookieCustom} from "./cookiemanagement";


const generateSessionId = (length) => {
    let result           = '';
    let characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let charactersLength = characters.length;
    for ( let i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() *
 charactersLength));
   }
   return result;
};

export const setSessionId = (sessionExpiry) => {
    let sessionId = getCookieCustom('sessionId')
    if (sessionId == null && sessionExpiry) {
        sessionId = generateSessionId(25);
        setCookieCustom('sessionId', sessionId, sessionExpiry)
    }
};

export const getSessionId = () => {
    const data = getCookieCustom('sessionId');
    return data;
};
